export default "__VITE_ASSET__UFnzWztK__";